import { defineMessages } from 'react-intl';

type MessageKeys =
	| 'researchCompletedNotificationTitle'
	| 'researchCompletedNotificationBody'
	| 'deepResearchNotificationPanelText'
	| 'deepResearchNotificationButtonText'
	| 'deepResearchNotificationConfirmationLabelText';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		researchCompletedNotificationTitle: {
			id: 'ai-mate.chat-history.message-research.research-completed-notification-title',
			defaultMessage: 'Rovo Chat completed research',
			description: 'Title for the research completed notification',
		},
		researchCompletedNotificationBody: {
			id: 'ai-mate.chat-history.message-research.research-completed-notification-body',
			defaultMessage: 'Your research has been completed and is ready to view.',
			description: 'Body for the research completed notification',
		},
		deepResearchNotificationPanelText: {
			id: 'ai-mate.chat-history.message-research-notification-text',
			defaultMessage:
				'Deep research can take a few minutes, but the results are worth the wait. You can continue working, just keep this chat window open.',
			description:
				'Information text displayed in a notification panel within the AI conversation interface when deep research is in progress, explaining the expected duration and user expectations. Shown as informational text in a notification panel. The purpose is to set user expectations about the time required for deep research and reassure them that they can continue working while waiting, as long as they keep the chat window open.',
		},
		deepResearchNotificationButtonText: {
			id: 'ai-mate.chat-history.message-research-notification-button-text',
			defaultMessage: 'Notify me when it’s done',
			description:
				'Button label displayed on a button in the deep research notification panel within the AI conversation interface that enables browser notifications when research completes. Shown as the text on a button. When clicked, it enables notifications and confirms that the user will be notified when the research finishes. The purpose is to allow users to receive a notification when research completes, so they can step away from the chat window.',
		},
		deepResearchNotificationConfirmationLabelText: {
			id: 'ai-mate.chat-history.message-research-notification-confirmation-label-text',
			defaultMessage: 'We’ll notify you when it’s done',
			description:
				'Confirmation message text displayed in the deep research notification panel within the AI conversation interface after a user has enabled notifications. Shown as confirmation text or a status message. The purpose is to confirm to the user that notifications have been enabled and they will be alerted when the deep research process completes.',
		},
	});

export default message;
